import React, { useState } from "react";
import { Layout, Menu, Button, message } from "antd";

import "./layout.css";
import { Routes, Route, useNavigate, Navigate, useLocation } from "react-router-dom";
import {
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
  QuestionCircleOutlined,
  AppstoreOutlined,
  BranchesOutlined,
  SmileOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { accessToken, refreshToken, userData } from "../redux/userDataSlice";
import { routes } from "../api/routes";
import { callApi } from "../api/apiCaller";
import Users from "../pages/userlist/Users";
import Notifications from "../pages/notifications/notifications";
import FAQs from "../pages/faqs/faqs";
import Categories from "../pages/categories/categories";
import SubCategories from "../pages/subCategories/subCategories";
import Moments from "../pages/moments/moments";
import ChatEmojis from "../pages/chatEmojis/chatEmojis";
import AiMessageModes from "../pages/aiMessageModes/aiMessageModes";
import TermsConditions from "../pages/termsConditions/termsConditions";
import PrivacyPolicy from "../pages/privacyPolicy/privacyPolicy";
import { termsConIcon, privacyIcon, AppLogo } from "../assets";
import Loader from "../components/loader/loader";

const { Header, Sider, Content } = Layout;
const LayoutDashboard = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [loggingOut, setLoggingOut] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const clearSessionAndRedirect = () => {
    dispatch(userData(null));
    dispatch(accessToken(""));
    dispatch(refreshToken(""));
    navigate("/login", { replace: true });
  };

  const logOut = () => {
    const body = {
      device: {
        id: "3242fwefwe4324",
      },
    };

    const onSuccess = (res) => {
      if (res.status === 200) {
        clearSessionAndRedirect();
      } else {
        message.warning("Logout API respond with unexpected status, clearing session locally.");
        clearSessionAndRedirect();
      }
    };

    const onError = (error) => {
      const errorMsg = error?.message || error?.response?.data?.message || "Failed to logout from server, clearing session locally.";
      message.error(errorMsg);
      clearSessionAndRedirect();
    };

    callApi("POST", routes.logOut, body, setLoggingOut, onSuccess, onError);
  };

  const getSelectedKey = () => {
    const path = location.pathname;

    if (path === "/" || path.startsWith("/customers")) return "1";
    if (path.startsWith("/categories")) return "2";
    if (path.startsWith("/subcategories")) return "3";
    if (path.startsWith("/moments")) return "4";
    if (path.startsWith("/faqs")) return "5";
    if (path.startsWith("/chat-emojis")) return "6";
    if (path.startsWith("/ai-message-modes")) return "7";
    if (path.startsWith("/privacy-policy")) return "8";
    if (path.startsWith("/terms-conditions")) return "9";

    return "";
  };
  return (
    <Layout className="admin-layout">
      <Loader loading={loggingOut} />
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width="15%" // Explicitly set to 20%
        className="admin-sider"
        theme="light"
        breakpoint="lg"
      >
        <div style={{ height: 32, margin: 16, textAlign: "center" }}>
          {/* You can put your logo here */}
          <span style={{ color: "#FF66B2", fontSize: 18, fontWeight: "bold" }}>
            {"Ignisia"}
          </span>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[getSelectedKey()]}
          items={[
            {
              key: "1",
              icon: <UserOutlined />,
              label: "Customers",
              onClick: () => navigate("/customers"),
            },
            {
              key: "2",
              icon: <AppstoreOutlined />,
              label: "Categories",
              onClick: () => navigate("/categories"),
            },
            {
              key: "3",
              icon: <BranchesOutlined />,
              label: "SubCategories",
              onClick: () => navigate("/subcategories"),
            },
            {
              key: "4",
              icon: (
                <img
                  src={AppLogo}
                  alt="moments"
                  style={{ width: 16, marginTop: 2, filter: "grayscale(100%) brightness(0)" }}
                />
              ),
              label: "Moments",
              onClick: () => navigate("/moments"),
            },
            {
              key: "5",
              icon: <QuestionCircleOutlined />,
              label: "Faqs",
              onClick: () => navigate("/faqs"),
            },
            {
              key: "6",
              icon: <SmileOutlined />,
              label: "Chat Emojis",
              onClick: () => navigate("/chat-emojis"),
            },
            {
              key: "7",
              icon: <RobotOutlined />,
              label: "AI Message Modes",
              onClick: () => navigate("/ai-message-modes"),
            },
            {
              key: "8",
              icon: (
                <img
                  src={privacyIcon}
                  alt="privacy"
                  style={{ width: 16, marginTop: 2 }}
                />
              ),
              label: "Privacy Policy",
              onClick: () => navigate("/privacy-policy"),
            },
            {
              key: "9",
              icon: (
                <img
                  src={termsConIcon}
                  alt="terms"
                  style={{ width: 16, marginTop: 2 }}
                />
              ),
              label: "Terms Conditions",
              onClick: () => navigate("/terms-conditions"),
            },
            {
              key: "10",
              icon: <LogoutOutlined />,
              label: "Logout",
              onClick: () => logOut(),
            },
          ]}
        />
      </Sider>

      <Layout>
        <Header className="admin-header">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
              marginRight: 16, // Space between button and title
            }}
          />
          <h1 className="header-title">Ignisia Admin Panel</h1>
        </Header>

        <Content className="admin-content">
          <Routes>
            <Route path="/" element={<Navigate to="/customers" replace />}></Route>
            <Route path="/customers" element={<Users />}></Route>
            <Route path="/notifications" element={<Notifications />}></Route>
            <Route path="/chat-emojis" element={<ChatEmojis />}></Route>
            <Route path="/ai-message-modes" element={<AiMessageModes />}></Route>
            <Route path="/faqs" element={<FAQs />}></Route>
            <Route path="/categories" element={<Categories />}></Route>
            <Route path="/subcategories" element={<SubCategories />}></Route>
            <Route path="/moments" element={<Moments />}></Route>
            <Route
              path="/terms-conditions"
              element={<TermsConditions />}
            ></Route>
            <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutDashboard;
